export default __webpack_public_path__ + "static/media/prevArrow.fc260185.webp";